export const dateFormat = (timestamp, dateStyle) => {
  const date = new Date(timestamp)
  const formatter = new Intl.DateTimeFormat("en-US", { dateStyle: dateStyle ? dateStyle : "medium" })
  const formatted = formatter.format(date)
  return formatted
}
